import { useState } from 'react';
import { Form, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useGetManyTrips } from 'api/trips/use-get-many-trips.ts';
import type { TSelectOptionChange } from 'types/select-option';
import type { ITripFormSelectProps } from './types';

export const TripFormSelect = (props: ITripFormSelectProps) => {
  const {
    name,
    handleChange,
    placeholder,
    label,
    rules,
    wrapperClassName,
    disable = false,
    excludeTripId,
    filters,
    onTripSelect,
  } = props;

  const [search, setSearch] = useState('');
  const { data: trips, isLoading } = useGetManyTrips({ limit: 10, search: search, filters });

  const handleClientSearch = debounce((value: string) => setSearch(value), 400);
  const filteredTrips = trips?.data?.filter((trip) => {
    if (trip.id === excludeTripId) return false;

    if (filters?.statuses && !filters.statuses.includes(trip.status)) return false;

    return true;
  });

  const options = filteredTrips?.map((trip) => ({
    value: trip.id,
    label: `${trip.compositeId} - ${trip.status}`,
  }));

  const handleSelectChange: TSelectOptionChange<number> = (option) => {
    handleChange(option);

    if (onTripSelect) {
      const selectedTrip = filteredTrips?.find((trip) => trip.id === option.value);
      onTripSelect?.(selectedTrip);
    }
  };

  return (
    <Form.Item label={label} name={name} rules={rules} className={wrapperClassName}>
      <Select
        placeholder={placeholder}
        loading={isLoading}
        filterOption={false}
        notFoundContent={null}
        disabled={disable}
        options={options}
        showSearch
        labelInValue
        onChange={handleSelectChange}
        onSearch={handleClientSearch}
      />
    </Form.Item>
  );
};
